import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ErrorService} from '@app/services';
import {PlateauSearchParams} from '../plateau-search-params';
import {PlateauService} from '../plateau.service';
@Component({
  selector: 'hpf-plateau-count',
  templateUrl: './plateau-count.component.html'
})
export class PlateauCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: PlateauSearchParams = new PlateauSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private plateauService: PlateauService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.plateauService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
